import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

import { CreationWizard } from '@/features/creation/components/creation-wizard'

export const Route = createFileRoute('/create/')({
  validateSearch: z.object({
    projectId: z.string().uuid().optional(),
  }),
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated) {
      throw redirect({ to: '/login' })
    }
  },
  component: CreatePage,
})

function CreatePage() {
  const { projectId } = Route.useSearch()
  return <CreationWizard requestedProjectId={projectId} />
}
